import { Game } from './Game.js';

const container = document.body;
const game = new Game(container);
